module.exports = __webpack_public_path__ + "img/usach.266c46b6.png";